import { render } from "./App.vue?vue&type=template&id=6e0fbf16&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6e0fbf16&scoped=true&lang=css"

import exportComponent from "/var/www/ment-test/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0fbf16"]])

export default __exports__